import { styled, css } from "../../../../../../../styles";
import { CancelButton } from "../../../../../../Settings/components/SecurityModal/SecurityModal.styles";

// Components

export const ModalContentContainer = styled("div", {
  height: "100%",
  width: "100%",
  overflowY: "overlay",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "rgba(248, 248, 248, 0.8)",
  padding: "5px",

  "&::-webkit-scrollbar": {
    width: "$4",
  },

  "&:hover": {
    "&::-webkit-scrollbar": {
      width: "$4",
      backgroundColor: "transparent",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "$gray-50",
      borderRadius: "10px",
    },
  },
});

export const EditorContainer = styled("div", {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const QuestionDetailsContainer = styled("div", {
  width: "100%",

  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",

  rowGap: "12px",
  pointerEvents: "auto",

  ".ant-select": {
    height: "42px !important",
  },

  p: {
    margin: 0,
    color: "$charcoal",
    fontSize: "14px",
    lineHeight: "20px",
    fontFamily: "$openSans",
  },
});

/** Label column, then the control(s): the same grid as the survey card. */
export const QuestionDetailsContainerRow = styled("div", {
  display: "grid",
  gridTemplateColumns: "160px max-content max-content",
  alignItems: "center",
  columnGap: "24px",
  minHeight: "42px",

  variants: {
    spaceRight: {
      true: {},
    },
  },
});

export const ToggleStyleClass = css({
  "&:hover": {
    cursor: "pointer",
  },
  marginRight: "10px",
});

// Its label and toggle sit in the row's grid columns.
export const ConditionalJumpToggleContainer = styled("div", {
  display: "contents",
});

export const HandleQuestionFormContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "30px 0 0px 16px",
});

export const EditorFooter = styled("div", {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "12px",
  marginTop: "8px",
});

export const SectionContainer = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  padding: "10px 0 0 10px",

  p: {
    marginRight: "10px",
  },
});

// CSS

export const textInputCss = css({
  width: "60px",

  span: {
    margin: "0px",
  },

  p: {
    width: "100% !important",
  },

  input: {
    border: "2px solid $gray-50",
    borderRadius: "6px",
    paddingLeft: "11px",
    paddingRight: "11px",
  },
});

/** Cancel beside Save in a card being edited (question or survey details). */
export const EditorCancelButton = styled(CancelButton, {
  border: "2px solid rgba(248, 248, 248, 0.8)",
  backgroundColor: "rgba(248, 248, 248, 0.8)",
});
